import { c as _c } from "react/compiler-runtime";
import { Box, Stack } from '@chakra-ui/react';
import { useParentAppLayout } from '@src/components/sco/AppLayout/AppLayoutContext';
import { AppLayoutToolbar } from '@src/components/sco/AppLayout/Toolbar/AppLayoutToolbar.tsx';
import { CourseToolbar } from '@src/components/sco/Education/Layout/CourseToolbar';
import { VideoToolbar } from '@src/components/sco/Education/Layout/VideoToolbar';
import { useCourseToolbar, useContentTrackStep } from '@src/components/sco/Education/Layout/educationHelpers';
import { usePathname } from 'next/navigation';
import { useRouter } from 'next/router';
import React, { useEffect, useRef, useState } from 'react';
export const EducationMainPanel = props => {
  const $ = _c(33);
  const layout = useParentAppLayout();
  const router = useRouter();
  const pathname = usePathname();
  const scrollRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["/videos/[videoListSlug]/[videoSlug]"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const showVideoToolbar = useCourseToolbar(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["/courses/[contentTrackSlug]/*"];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const showCourseToolbar = useCourseToolbar(t1);
  const {
    contentTrackStep
  } = useContentTrackStep(router.query.contentTrackSlug as string, router.query.contentTrackSectionSlug as string, router.query.contentTrackStepSlug as string);
  let t2;
  if ($[2] !== layout) {
    t2 = layout.getPanel("edu-nav");
    $[2] = layout;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const [isNavPanelOpen, setIsNavPanelOpen] = useState(t2.isPanelOpen);
  let t3;
  if ($[4] !== layout) {
    t3 = layout.getPanel("edu-aside");
    $[4] = layout;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const [isAsidePanelOpen, setIsAsidePanelOpen] = useState(t3.isPanelOpen);
  let t4;
  let t5;
  if ($[6] !== layout) {
    t4 = () => {
      setIsNavPanelOpen(layout.getPanel("edu-nav").isPanelOpen);
    };
    t5 = layout.getPanel("edu-nav");
    $[6] = layout;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5.isPanelOpen) {
    t6 = [t5.isPanelOpen];
    $[9] = t5.isPanelOpen;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  useEffect(t4, t6);
  let t7;
  let t8;
  if ($[11] !== isAsidePanelOpen) {
    t7 = () => {
      setIsAsidePanelOpen(isAsidePanelOpen);
    };
    t8 = [isAsidePanelOpen];
    $[11] = isAsidePanelOpen;
    $[12] = t7;
    $[13] = t8;
  } else {
    t7 = $[12];
    t8 = $[13];
  }
  useEffect(t7, t8);
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      if (scrollRef.current) {
        scrollRef.current.scrollTo(0, 0);
      }
    };
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== pathname) {
    t10 = [pathname];
    $[15] = pathname;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  useEffect(t9, t10);
  let t11;
  if ($[17] !== contentTrackStep || $[18] !== isAsidePanelOpen || $[19] !== isNavPanelOpen || $[20] !== router.query.contentTrackSectionSlug || $[21] !== router.query.contentTrackSlug || $[22] !== router.query.contentTrackStepSlug || $[23] !== router.query.videoListSlug || $[24] !== router.query.videoSlug || $[25] !== showCourseToolbar || $[26] !== showVideoToolbar) {
    t11 = () => {
      if (showVideoToolbar) {
        return <VideoToolbar videoListSlug={`${router.query.videoListSlug}`} videoSlug={`${router.query.videoSlug}`} />;
      } else {
        if (showCourseToolbar) {
          return <CourseToolbar contentTrackSectionSlug={`${router.query.contentTrackSectionSlug}`} contentTrackSlug={`${router.query.contentTrackSlug}`} contentTrackStep={contentTrackStep} contentTrackStepSlug={`${router.query.contentTrackStepSlug}`} isAsidePanelOpen={isAsidePanelOpen} isNavPanelOpen={isNavPanelOpen} />;
        }
      }
      return <AppLayoutToolbar />;
    };
    $[17] = contentTrackStep;
    $[18] = isAsidePanelOpen;
    $[19] = isNavPanelOpen;
    $[20] = router.query.contentTrackSectionSlug;
    $[21] = router.query.contentTrackSlug;
    $[22] = router.query.contentTrackStepSlug;
    $[23] = router.query.videoListSlug;
    $[24] = router.query.videoSlug;
    $[25] = showCourseToolbar;
    $[26] = showVideoToolbar;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  const renderToolbar = t11;
  let t12;
  if ($[28] !== renderToolbar) {
    t12 = renderToolbar();
    $[28] = renderToolbar;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== props.children || $[31] !== t12) {
    t13 = <Box position="relative" width="full"><Stack direction="column" gap={0} justify="stretch">{t12}{props.children}</Stack></Box>;
    $[30] = props.children;
    $[31] = t12;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  return t13;
};